import { Link } from '~/components/Link'

const className = 'font-medium text-xs text-white'

export default function TCItem({
  label,
  to,
  onClick,
}: {
  label: string
  to?: string
  onClick?: () => void
}): React.ReactElement {
  if (to) {
    return (
      <Link className={className} onClick={onClick} to={to}>
        {label}
      </Link>
    )
  }

  return (
    <button className={`${className} cursor-pointer border-0 bg-transparent p-0`} onClick={onClick} type="button">
      {label}
    </button>
  )
}
